import { render, staticRenderFns } from "./StudentStatementDetail.vue?vue&type=template&id=0019f4c0"
import script from "../../../controllers/custom/student_statement/student-statement-detail.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/student_statement/student-statement-detail.js?vue&type=script&lang=js&external"
import style0 from "./StudentStatementDetail.vue?vue&type=style&index=0&id=0019f4c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports